var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { View } from "./view";
import LocalStorageService from "../../services/localStorage";
import { useGetPlansAll } from "../../fnx/plans/plansGetAll";
import { usePremiumEvalOptionGetAll } from "../../fnx/premiumEvalOption/premiumEvalOptionGetAll";
import { usePlansPatch } from "../../fnx/plans/plansPatch";
import { usePlanPost } from "../../fnx/plans/plansPost";
import { useCoverTypePost } from "../../fnx/coverType/coverTypePost";
import { useCoverTypePlanPost } from "../../fnx/coverTypePlan/coverTypePlanPost";
import { deleteEntity, deleteEntityClearData } from "../../store/delete/actions";
import { position, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var PlanAdmin = function () {
    var dispatch = useDispatch();
    var _a = useState([]), list = _a[0], setList = _a[1];
    var _b = useState(), filters = _b[0], setFilters = _b[1];
    var _c = useState([]), listPremiumEvalOption = _c[0], setPremiumEvalOption = _c[1];
    var _d = useState(false), trigger = _d[0], setTrigger = _d[1];
    var _e = useState(false), triggerPremiumGetAll = _e[0], setTriggerPremiumGetAll = _e[1];
    var _f = useState(false), triggerPost = _f[0], setTriggerPost = _f[1];
    var _g = useState(false), triggerCoverTypePost = _g[0], setTriggerCoverTypePost = _g[1];
    var _h = useState(false), triggerCoverTypePlanPost = _h[0], setTriggerCoverTypePlanPost = _h[1];
    var _j = useState(false), triggerPatch = _j[0], setTriggerPatch = _j[1];
    var _k = useState(), planFormData = _k[0], setPlanFormData = _k[1];
    var _l = useState(""), planId = _l[0], setPlanId = _l[1];
    var _m = useState({ id: "", name: "", code: "", projectId: "" }), planRequest = _m[0], setPlanRequest = _m[1];
    var _o = useState({ id: "", code: "", description: "" }), coverTypeRequest = _o[0], setCoverTypeRequest = _o[1];
    var _p = useState({ id: "", coverTypeId: "", premiumEvalOptionId: "", planId: "" }), coverTypePlanRequest = _p[0], setCoverTypePlanRequest = _p[1];
    var _q = useState(false), openModal = _q[0], setOpenModal = _q[1];
    var _r = useState(false), openModalConfirm = _r[0], setOpenModalConfirm = _r[1];
    var _s = useState(false), openModalCloneConfirm = _s[0], setOpenModalCloneConfirm = _s[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _t = useState(false), isUpdate = _t[0], setIsUpdate = _t[1];
    var _u = useState(null), itemModal = _u[0], setitemModal = _u[1];
    var _v = useState({
        CodePlan: "",
        Name: "",
    }), dataForm = _v[0], setDataForm = _v[1];
    var _w = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _w[0], setSeeToast = _w[1];
    var _x = useGetPlansAll(trigger, clientId), responsePlans = _x.responsePlans, errorPlans = _x.errorPlans, loadingPlans = _x.loadingPlans;
    var _y = usePremiumEvalOptionGetAll(triggerPremiumGetAll), responsePremiumEvalOption = _y.responsePremiumEvalOption, errorPremiumEvalOption = _y.errorPremiumEvalOption, loadingPremiumEvalOption = _y.loadingPremiumEvalOption;
    var _z = usePlanPost(triggerPost, planRequest), responsePostPlans = _z.responsePostPlans, errorPostPlans = _z.errorPostPlans, loadingPostPlans = _z.loadingPostPlans;
    var _0 = useCoverTypePost(triggerCoverTypePost, coverTypeRequest), responsePostCoverType = _0.responsePostCoverType, errorPostCoverType = _0.errorPostCoverType, loadingPostCoverType = _0.loadingPostCoverType;
    var _1 = useCoverTypePlanPost(triggerCoverTypePlanPost, coverTypePlanRequest), responsePostCoverTypePlan = _1.responsePostCoverTypePlan, errorPostCoverTypePlan = _1.errorPostCoverTypePlan, loadingPostCoverTypePlan = _1.loadingPostCoverTypePlan;
    var _2 = usePlansPatch(triggerPatch, planRequest), responsePatchPlans = _2.responsePatchPlans, errorPatchPlans = _2.errorPatchPlans, loadingPatchPlans = _2.loadingPatchPlans;
    var _3 = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _3.responseDeleteEntity, loadingDeleteEntity = _3.loadingDeleteEntity, errorDeleteEntity = _3.errorDeleteEntity;
    useEffect(function () {
        if (!(responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.data)) {
            setTrigger(true);
        }
        if (!(responsePremiumEvalOption === null || responsePremiumEvalOption === void 0 ? void 0 : responsePremiumEvalOption.data)) {
            setTriggerPremiumGetAll(true);
        }
    }, []);
    useEffect(function () {
        var _a, _b;
        if (responsePlans && (responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.length) > 0) {
            var list_1 = responsePlans.map(function (item) { return ({
                id: item.id,
                title: item.name,
                code: item.code,
                currency: '$',
                period: 'Mes',
                price: "0",
            }); });
            setList(list_1);
            setFilters([
                {
                    name: "Sponsor",
                    label: (_a = responsePlans[0].projectInfo) === null || _a === void 0 ? void 0 : _a.fkSponsor.name,
                    type: "label",
                },
                {
                    name: "Tipo",
                    label: (_b = responsePlans[0].projectInfo) === null || _b === void 0 ? void 0 : _b.description,
                    type: "label",
                },
                {
                    name: "Reglas",
                    label: responsePlans[0].scenaries[0].name,
                    type: "label",
                },
            ]);
        }
    }, [responsePlans]);
    useEffect(function () {
        if (responsePremiumEvalOption && (responsePremiumEvalOption === null || responsePremiumEvalOption === void 0 ? void 0 : responsePremiumEvalOption.length) > 0) {
            var list_2 = responsePremiumEvalOption.map(function (item) { return ({
                id: item.id,
                value: item.id,
                name: item.description,
            }); });
            setPremiumEvalOption(list_2);
        }
    }, [responsePremiumEvalOption]);
    useEffect(function () {
        if (responsePostPlans && responsePostPlans) {
            setPlanId(responsePostPlans === null || responsePostPlans === void 0 ? void 0 : responsePostPlans.id);
            setCoverTypeRequest({ code: planFormData === null || planFormData === void 0 ? void 0 : planFormData.CoverTypeCode, description: planFormData === null || planFormData === void 0 ? void 0 : planFormData.CoverTypeDescription });
            setTriggerCoverTypePost(true);
            setTriggerPost(false);
        }
    }, [responsePostPlans]);
    useEffect(function () {
        if (responsePostCoverType) {
            setCoverTypePlanRequest({ planId: planId, coverTypeId: responsePostCoverType === null || responsePostCoverType === void 0 ? void 0 : responsePostCoverType.id, premiumEvalOptionId: planFormData === null || planFormData === void 0 ? void 0 : planFormData.IdOption });
            setTriggerCoverTypePlanPost(true);
            setTriggerCoverTypePost(false);
        }
    }, [responsePostCoverType]);
    useEffect(function () {
        if (responsePostCoverTypePlan) {
            setTriggerCoverTypePlanPost(false);
        }
    }, [responsePostCoverTypePlan]);
    useEffect(function () {
        if (responseDeleteEntity) {
            setSeeToast({
                show: true,
                message: "Eliminado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
            dispatch(deleteEntityClearData());
            setTrigger(true);
        }
        else if (errorDeleteEntity) {
            setSeeToast({
                show: true,
                message: errorDeleteEntity === null || errorDeleteEntity === void 0 ? void 0 : errorDeleteEntity.message.message,
                type: typeAlert.error,
            });
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    useEffect(function () {
        setTriggerPatch(false);
        if (responsePatchPlans && responsePatchPlans.data) {
            setSeeToast({
                show: true,
                message: "Actualizado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
            setTrigger(true);
            //dispatch(patchSponsorClearData());
        }
        else if (errorPatchPlans) {
            setSeeToast({
                show: true,
                message: errorPatchPlans === null || errorPatchPlans === void 0 ? void 0 : errorPatchPlans.message,
                type: typeAlert.error,
            });
        }
    }, [responsePatchPlans, errorPatchPlans]);
    var showEdit = function (row) {
        setDataForm(__assign(__assign({}, dataForm), { CodePlan: row.code, Name: row.title }));
    };
    var handleSubmit = function (dataItem) {
        if (isUpdate) {
            var id = dataForm.Id;
            setPlanRequest({ id: id, name: dataItem.Name, code: dataItem.code, projectId: dataItem.projectId });
            setTriggerPatch(true);
        }
        else {
            var body = {
                clientId: dataItem.clientId,
                name: dataItem.Name,
            };
            setPlanRequest({ name: dataItem.Name, code: dataItem.code, projectId: dataItem.projectId });
            setTriggerPost(true);
        }
        setOpenModal(false);
    };
    var handleOpenModal = function () {
        setOpenModal(true);
    };
    var handleOnNext = function (data) {
        var datax = {
            name: data.Name,
            code: data.CodePlan,
            projectId: "f52f2599-aba1-4fa9-be8a-4f71c7a1d33a"
        };
        setPlanRequest(datax);
        setPlanFormData({ PlanName: data.Name, CodePlan: data.CodePlan, CoverTypeCode: data.CodeInfoPlan, CoverTypeDescription: data.Description, IdOption: data.IdOption });
        setTriggerPost(true);
    };
    var handleOpenModalConfirm = function () {
        setOpenModalConfirm(true);
    };
    var handleOpenModalCloneConfirm = function () {
        setOpenModalCloneConfirm(true);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
    };
    var handleOnClickAdd = function () {
        setIsUpdate(false);
        setOpenModal(true);
        setDataForm(__assign(__assign({}, dataForm), { CodePlan: "", Name: "" }));
    };
    var handleOnClickButtonOptionsDropdown = function (opt, item) {
        if (opt.id === "1") {
            setIsUpdate(true);
            setOpenModal(true);
            showEdit(item);
        }
        else if (opt.id === "2") {
            setitemModal(item);
            setOpenModalConfirm(true);
        }
        else if (opt.id === "3") {
            setitemModal(item);
            setOpenModalCloneConfirm(true);
        }
    };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleCloseModalConfirm = function () {
        setOpenModal(false);
        setOpenModalConfirm(false);
    };
    var handleCloseCloneModal = function () {
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
    };
    var handleDelete = function () {
        setOpenModal(false);
        setOpenModalConfirm(false);
        dispatch(deleteEntity({ id: itemModal.id, entity: "PlanEntity", idUser: "d2bd577e-c8c6-4519-b30a-b8e674c42952" }));
    };
    var handleClone = function () {
    };
    return (_jsxs(React.Fragment, { children: [seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () { setSeeToast({ show: false, message: "", type: typeAlert.success }); }), _jsx(View, { title: "Plan", list: list, openModal: openModal, openModalConfirm: openModalConfirm, openModalCloneConfirm: openModalCloneConfirm, loadingPost: null, dataForm: dataForm, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, Options: listPremiumEvalOption, filters: filters, clickView: clickView, onSubmit: handleDelete, onSubmitClone: handleClone, onClose: handleCloseModal, onCloseConfirm: handleCloseModalConfirm, onCloseCloneModal: handleCloseCloneModal, handleOpenModal: handleOpenModal, handleOpenModalConfirm: handleOpenModalConfirm, handleOpenModalCloneConfirm: handleOpenModalCloneConfirm, onNext: function (data) {
                    handleOnNext(data);
                }, onSaveData: handleSubmit, onClickAdd: handleOnClickAdd, onClickButtonOptionsDropdown: function (opt, item) { handleOnClickButtonOptionsDropdown(opt, item); } })] }));
};
export default PlanAdmin;
